module.exports = __webpack_public_path__ + "img/ch10_04_JK姐妹装.82f2698e.jpg";